export default "__VITE_PUBLIC_ASSET__73c7ef2b__"